import _ from 'lodash';

const piePalette = { 'Baixa-1': '#348ECA', 'Media-2': '#2D5269', 'Alta-3': '#00ABA4' };

function getDadosGraficosGeral(monitoramento, dadosComportamentos) {
  return {
    comportamento: {
      bar: {
        dados: [{
          name: 'Unidade',
          data: dadosComportamentos.sort((a, b) => {
            if (a.y < b.y) { return 1; }
            if (a.y > b.y) { return -1; }
            return 0;
          }),
          color: '#2D5269',
        }],
        categorias: dadosComportamentos.map((d) => d.unidade),
      },
      pie: {
        series: [
          {
            name: 'Categorias',
            data: [
              {
                name: 'Gosto',
                y: monitoramento.comportamentos.gosto,
                drilldown: _.sumBy(monitoramento.dados, 'comportamentos.gosto') ? 'gosto' : null,
              },
              {
                name: 'Não Gosto',
                y: monitoramento.comportamentos.naoGosto,
                drilldown: _.sumBy(monitoramento.dados, 'comportamentos.naoGosto') ? 'naoGosto' : null,
              },
              {
                name: 'Ideal Seria',
                y: monitoramento.comportamentos.ideal,
                drilldown: _.sumBy(monitoramento.dados, 'comportamentos.ideal') ? 'ideal' : null,
              },
            ],
          },
        ],
        subSeries: [
          {
            name: 'Gosto',
            id: 'gosto',
            data: monitoramento.dados.filter((d) => d.comportamentos.gosto > 0)
              .map((d) => ([d.unidade.sigla, d.comportamentos.gosto])),
          },
          {
            name: 'Não Gosto',
            id: 'naoGosto',
            data: monitoramento.dados.filter((d) => d.comportamentos.naoGosto > 0)
              .map((d) => ([d.unidade.sigla, d.comportamentos.naoGosto])),
          },
          {
            name: 'Ideal Seria',
            id: 'ideal',
            data: monitoramento.dados.filter((d) => d.comportamentos.ideal > 0)
              .map((d) => ([d.unidade.sigla, d.comportamentos.ideal])),
          },
        ],
      },
    },
    responsabilidade: {
      pie: {
        series: [
          {
            name: 'Impactos',
            data: [
              {
                name: 'Impacto 1',
                y: monitoramento.responsabilidadesConsolidadas.impactoUm,
                color: piePalette['Baixa-1'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.impactoUm')
                  ? 'impactoUm' : null,
              },
              {
                name: 'Impacto 2',
                y: monitoramento.responsabilidadesConsolidadas.impactoDois,
                color: piePalette['Media-2'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.impactoDois')
                  ? 'impactoDois' : null,
              },
              {
                name: 'Impacto 3',
                y: monitoramento.responsabilidadesConsolidadas.impactoTres,
                color: piePalette['Alta-3'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.impactoTres')
                  ? 'impactoTres' : null,
              },
            ].sort((a, b) => {
              if (a.y > b.y) { return -1; }
              if (a.y < b.y) { return 1; }
              return 0;
            }),
          },
        ],
        subSeries: [
          {
            name: 'Impacto 1',
            id: 'impactoUm',
            data: monitoramento.dados.filter((d) => d.responsabilidadesConsolidadas.impactoUm > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.impactoUm]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
          {
            name: 'Impacto 2',
            id: 'impactoDois',
            data: monitoramento.dados.filter((d) => d.responsabilidadesConsolidadas.impactoDois > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.impactoDois]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
          {
            name: 'Impacto 3',
            id: 'impactoTres',
            data: monitoramento.dados.filter((d) => d.responsabilidadesConsolidadas.impactoTres > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.impactoTres]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
        ],
      },
      pie2: {
        series: [
          {
            name: 'Dificuldades',
            data: [
              {
                name: 'Dificuldade 1',
                y: monitoramento.responsabilidadesConsolidadas.dificuldadeUm,
                color: piePalette['Baixa-1'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.dificuldadeUm')
                  ? 'dificuldadeUm' : null,
              },
              {
                name: 'Dificuldade 2',
                y: monitoramento.responsabilidadesConsolidadas.dificuldadeDois,
                color: piePalette['Media-2'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.dificuldadeDois')
                  ? 'dificuldadeDois' : null,
              },
              {
                name: 'Dificuldade 3',
                y: monitoramento.responsabilidadesConsolidadas.dificuldadeTres,
                color: piePalette['Alta-3'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.dificuldadeTres')
                  ? 'dificuldadeTres' : null,
              },
            ].sort((a, b) => {
              if (a.y > b.y) { return -1; }
              if (a.y < b.y) { return 1; }
              return 0;
            }),
          },
        ],
        subSeries: [
          {
            name: 'Dificuldade 1',
            id: 'dificuldadeUm',
            data: monitoramento.dados
              .filter((d) => d.responsabilidadesConsolidadas.dificuldadeUm > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.dificuldadeUm]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
          {
            name: 'Dificuldade 2',
            id: 'dificuldadeDois',
            data: monitoramento.dados
              .filter((d) => d.responsabilidadesConsolidadas.dificuldadeDois > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.dificuldadeDois]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
          {
            name: 'Dificuldade 3',
            id: 'dificuldadeTres',
            data: monitoramento.dados
              .filter((d) => d.responsabilidadesConsolidadas.dificuldadeTres > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.dificuldadeTres]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
        ],
      },
      pie3: {
        series: [
          {
            name: 'Complexidades',
            data: [
              {
                name: 'Complexidade Alta',
                y: monitoramento.responsabilidadesConsolidadas.complexidadeAlta,
                color: piePalette['Alta-3'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.complexidadeAlta')
                  ? 'complexidadeAlta' : null,
              },
              {
                name: 'Complexidade Média',
                y: monitoramento.responsabilidadesConsolidadas.complexidadeMedia,
                color: piePalette['Media-2'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.complexidadeMedia')
                  ? 'complexidadeMedia' : null,
              },
              {
                name: 'Complexidade Baixa',
                y: monitoramento.responsabilidadesConsolidadas.complexidadeBaixa,
                color: piePalette['Baixa-1'],
                drilldown: _.sumBy(monitoramento.dados, 'responsabilidadesConsolidadas.complexidadeBaixa')
                  ? 'complexidadeBaixa' : null,
              },
            ].sort((a, b) => {
              if (a.y > b.y) { return -1; }
              if (a.y < b.y) { return 1; }
              return 0;
            }),
          },
        ],
        subSeries: [
          {
            name: 'Complexidade Alta',
            id: 'complexidadeAlta',
            data: monitoramento.dados
              .filter((d) => d.responsabilidadesConsolidadas.complexidadeAlta > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.complexidadeAlta]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
          {
            name: 'Complexidade Média',
            id: 'complexidadeMedia',
            data: monitoramento.dados
              .filter((d) => d.responsabilidadesConsolidadas.complexidadeMedia > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.complexidadeMedia]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
          {
            name: 'Complexidade Baixa',
            id: 'complexidadeBaixa',
            data: monitoramento.dados
              .filter((d) => d.responsabilidadesConsolidadas.complexidadeBaixa > 0)
              .map((d) => ([d.unidade.sigla, d.responsabilidadesConsolidadas.complexidadeBaixa]))
              .sort((a, b) => {
                if (a[1] > b[1]) { return -1; }
                if (a[1] < b[1]) { return 1; }
                return 0;
              }),
          },
        ],
      },
    },
    competenciaTecnica: {
      bar: {
        categorias: monitoramento.competenciasTecnicasConsolidadas.competenciasTecnicas
          .map((c) => c.competenciaTecnica.nome),
        dados: [
          {
            name: 'Quantidade',
            dataSorting: {
              enabled: true,
              sortKey: 'y',
            },
            data: monitoramento.competenciasTecnicasConsolidadas.competenciasTecnicas.map((c) => {
              if (c.competenciaTecnica.unidades.length === 0) {
                return { y: c.total, color: '#348ECA' };
              }
              return { y: c.total, color: 'grey' };
            }),
            color: '#ffffff',
          },
        ],
      },
    },
    loaded: true,
  };
}

export default getDadosGraficosGeral;
